import React from 'react';
import { ConnectorsPanel } from './connectors/ConnectorsPanel';

export const EmployeeAppsPanel: React.FC = () => (
  <div className="mx-auto max-w-[1000px]">
    <ConnectorsPanel mode="employee" />
    <p className="m-0 mt-4 text-[12.5px] leading-[20px] text-ink-dim">Search any app and connect it with your own account. Your sign-in stays yours: nobody else can use it.</p>
  </div>
);

export default EmployeeAppsPanel;
